/**
 * Primitive atomic value types.
 *
 * Union of basic serializable types for hashing and encoding.
 *
 * @example
 * ```ts
 * const values: Atom[] = [42, "hello", true, 123n]
 * ```
 */
export type Atom = bigint | boolean | number | string
